const orderStatusLabels = {
  notConfirmed: "در_انتظار_تایید",
  pending: "پرداخت_نشده",
  paid: "پرداخت_شده",
  canceled: "لغو_شده",
  delivered: "تکمیل_شده"
}

export default orderStatusLabels